/**
 * Novedades que se anuncian a los usuarios que ya usaban la app.
 *
 * Para anunciar algo nuevo, añade una entrada aquí. Sale como aviso en el
 * inicio de su módulo a quien tenga ese módulo y se diera de alta ANTES de
 * `publicada` (quien llega después ya lo encuentra hecho), hasta que lo cierra.
 * Lo cerrado queda en `usuarios/{uid}.novedadesVistas[id]`, así que vale en
 * cualquier dispositivo. No reutilices un `id`: los ya vistos no saldrían.
 */
export interface Novedad {
  id: string;
  /** Módulo en cuyo inicio se muestra. */
  modulo: string;
  /** YYYY-MM-DD. Solo la ven las cuentas creadas antes de este día. */
  publicada: string;
  titulo: string;
  texto: string;
  /** Texto del botón principal; la acción la pone la página que pinta el aviso. */
  accion?: string;
  /** Solo en la app de iOS (cosas del iPhone, como Apple Pay o Atajos). */
  soloApp?: boolean;
}

export const NOVEDADES: Novedad[] = [
  {
    id: 'plantilla-categorias',
    modulo: 'finanzas',
    publicada: '2026-10-07',
    titulo: 'Nuevo: categorías desde plantilla',
    texto: 'Puedes crear de golpe las categorías más habituales (vivienda, supermercado, nómina…) '
      + 'eligiendo cuáles quieres. Las que ya tienes no se duplican. '
      + 'Está en Configuración → Categorías → «Desde plantilla».',
    accion: 'Ver la plantilla',
  },
  {
    id: 'informes-nuevos',
    modulo: 'finanzas',
    publicada: '2026-10-29',
    titulo: 'Nuevo: informes renovados',
    texto: 'Ahora ves tu balance y tasa de ahorro, la evolución de los últimos 12 meses, '
      + 'cómo van tus presupuestos, en qué cuenta se va el dinero, tus huchas y tus gastos más grandes. '
      + 'Está en Informes.',
    accion: 'Ver los informes',
  },
  {
    id: 'apuntar-apple-pay',
    modulo: 'finanzas',
    publicada: '2026-11-10',
    titulo: 'Nuevo: apunta al pagar con Apple Pay',
    texto: 'Al pagar con Apple Pay, myarinn se abre con el gasto, la tienda y la cuenta de tu tarjeta. '
      + 'Y di «Oye Siri, apunta un gasto en myarinn» o búscalo en Atajos para apuntar a mano.',
    accion: 'Cómo se activa',
    soloApp: true,
  },
];
